export default __webpack_public_path__ + "static/media/client-26.4f219587.png";